import React from "react";
import { LoadScript } from "@react-google-maps/api";

const LIBRARIES = ["places"];
const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/**
 * Loads the Google Maps Places script only where address autocomplete is used,
 * so a slow or missing Maps response never blocks the rest of the site.
 * Without a configured key the children still render — the address field simply
 * falls back to plain text entry.
 */
const MapsProvider = ({ children }) => {
  if (!API_KEY) return children;

  return (
    <LoadScript
      googleMapsApiKey={API_KEY}
      libraries={LIBRARIES}
      loadingElement={
        <div className="centered-message" style={{ minHeight: "12rem" }}>
          <span className="loader-dot" aria-hidden="true" />
        </div>
      }
    >
      {children}
    </LoadScript>
  );
};

export default MapsProvider;
